export enum IDigitalProductBillingType {
    OneTime = 1,
    Recurring = 2
}
